import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/Table';
import { IClaim } from 'types/income';
import { exportXlsxConfig } from 'utils/general';
import { ClaimStatus, ClaimsFilters } from './claims.types';

interface GetClaims {
  filters: Partial<ClaimsFilters>;
}

interface GetClaim {
  claimId: string;
}

interface UpdateClaim {
  claimId: string;
  status?: ClaimStatus;
  adminComment?: string;
}

interface UpdateClaims {
  updates: Array<{ claimId: string; status: ClaimStatus }>;
}

interface ExportXls {
  filters: Partial<ClaimsFilters>;
}

export const loaders = {
  getClaims: ({ filters }: GetClaims) => {
    return api<TableDataResponse<IClaim>>({
      url: Endpoints.clientAdmin.claims.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        search: filters.search || undefined,
        filter: {
          companyId: filters.company,
          benefitId: filters.benefit,
          status: filters.status,
          mismatch: filters.mismatch,
          claimDateFrom: filters.claimDate?.from,
          claimDateTo: filters.claimDate?.to,
          purchaseDateFrom: filters.purchaseDate?.from,
          purchaseDateTo: filters.purchaseDate?.to,
        },
      },
    });
  },
  getClaim: ({ claimId }: GetClaim) => {
    return api<IClaim>({
      url: Endpoints.clientAdmin.claims.byId.replace(':claimId', claimId),
    });
  },
  updateClaim: ({ claimId, status, adminComment }: UpdateClaim) => {
    return api({
      url: Endpoints.clientAdmin.claims.byId.replace(':claimId', claimId),
      method: 'patch',
      data: {
        status,
        adminComment,
      },
    });
  },
  updateClaims: ({ updates }: UpdateClaims) => {
    return api({
      url: Endpoints.clientAdmin.claims.bulk,
      method: 'patch',
      data: {
        requests: updates,
      },
    });
  },
  exportXls: ({ filters }: ExportXls) => {
    return api({
      url: Endpoints.clientAdmin.claims.export.xls,
      params: {
        search: filters.search,
        filter: {
          companyId: filters.company,
          benefitId: filters.benefit,
          status: filters.status,
          mismatch: filters.mismatch,
          claimDateFrom: filters.claimDate?.from,
          claimDateTo: filters.claimDate?.to,
          purchaseDateFrom: filters.purchaseDate?.from,
          purchaseDateTo: filters.purchaseDate?.to,
        },
      },
      ...exportXlsxConfig,
    });
  },
};
